// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { maxWidth } from '@utils/helpers';

export const SelectWrapper = styled.div`
    position: relative;
`;

export const SelectButton = styled.button(
    ({ disabled }) => css`
        align-items: center;
        background-color: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        outline: none;
        padding: 0;
        user-select: none;
        ${disabled && 'pointer-events: none;'}

        ${maxWidth('md')} {
            gap: 6px;
        }
    `,
);

export const MobileLanguageLabel = styled(Typography.TextH4_20_28)<{
    isDisabled?: boolean;
}>(
    ({ isDisabled, theme: { palette } }) => css`
        line-height: normal;
        text-transform: uppercase;
        ${isDisabled && `color: ${palette.text.assistive}`}
    `,
);

export const SelectLabel = styled(Typography.TextBody_14_20)<{
    isDisabled?: boolean;
}>(
    ({ isDisabled, theme: { palette } }) => css`
        letter-spacing: -0.015em;
        margin: 0 4px 0 8px;
        ${isDisabled && `color: ${palette.text.assistive}`}
    `,
);

export const LanguageSelecWrapper = styled.div(
    ({ theme: { boxShadow, palette, radius } }) => css`
        background-color: ${palette.neutral.white};
        border-radius: ${radius[6]}px;
        box-shadow: ${boxShadow.big};
        overflow-y: hidden;
        position: absolute;
        right: -24px;
        top: calc(100% + 16px);
        width: 344px;
        z-index: 9;
    `,
);

export const LanguageSelectList = styled.div`
    height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const MobileLanguageListWrapper = styled(motion.div)`
    ${({ theme: { boxShadow, palette } }) => css`
        background-color: ${palette.neutral.white};
        box-shadow: ${boxShadow.small};
        display: grid;
        grid-template-rows: auto auto 1fr;
        height: 100vh;
        left: 0;
        padding-bottom: 32px;
        position: fixed;
        top: 0;
        width: calc(100vw - 40px);
        z-index: 99;
    `}
`;

export const CloseIconWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 24px 24px 16px;
`;

export const MobileListTitle = styled(Typography.TextH3_24_34)`
    padding: 0 30px;
`;

export const MobileLanguageList = styled.div(
    ({ theme: { palette } }) => css`
        background-color: ${palette.neutral.white};
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }
    `,
);

export const SelectItem = styled.div(
    ({ theme: { palette } }) => css`
        align-items: center;
        cursor: pointer;
        display: flex;
        gap: 16px;
        justify-content: space-between;
        padding: 6px 16px;

        &:hover {
            background-color: ${palette.tertiary.background};
        }

        ${maxWidth('md')} {
            padding: 10px 40px;
        }
    `,
);

export const SelectText = styled(Typography.TextBody_16_24)<{
    isActive?: boolean;
}>(
    ({ isActive, theme: { fontWeight } }) => css`
        ${isActive && `font-weight: ${fontWeight.bold};`}
    `,
);

export const SelectIconWrapper = styled.div`
    align-items: center;
    display: flex;

    svg {
        transition: none;

        circle,
        path,
        rect {
            transition: none;
        }
    }
`;

export const LanguageSelectInfo = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        padding: 16px;
        text-align: center;
    `,
);
